import React from "react";
import Navigation from "@/layout/navigation";

export default function TermsConditions() {
  return (
    <>
      {/* Header avec navigation */}
      <header className="bg-gradient-to-b from-white from-20% to-blue-300 flex flex-col gap-16 items-center justify-between overflow-hidden px-8 xl:px-0 z-[51] relative pb-20">
        <Navigation noMenu />
        <div className="flex flex-col md:items-center md:justify-center gap-4 mt-6 md:mt-10 z-10 md:text-center">
          <h1 className="text-4xl md:text-5xl font-medium leading-tight">
            Conditions Générales
          </h1>
          <p className="text-md max-w-2xl mx-auto text-slate-600">
            Ces conditions régissent votre utilisation de Featcal et décrivent nos droits et responsabilités mutuels.
          </p>
        </div>
      </header>

      {/* Contenu principal - ultra simple */}
      <div className="bg-white py-20 px-8 xl:px-0">
        <div className="max-w-3xl mx-auto">
          <div className="space-y-12 text-lg leading-relaxed text-gray-800">
            <div className="text-sm text-blue-600 font-medium">
              Dernière mise à jour : 28 septembre 2025
            </div>

            <div className="space-y-8">
              <p>
                Bienvenue sur Featcal. Ces Conditions Générales (&quot;Conditions&quot;) régissent votre accès et votre utilisation de notre plateforme, site web (featcal.com), applications mobiles et services connexes (collectivement, les &quot;Services&quot;) fournis par Featcal (&quot;nous,&quot; &quot;notre,&quot; ou &quot;nos&quot;).
              </p>

              <p>
                En accédant ou en utilisant nos Services, vous acceptez d&apos;être lié par ces Conditions. Si vous n&apos;acceptez pas ces Conditions, vous ne pouvez pas accéder ou utiliser nos Services.
              </p>

              <p className="font-semibold">
                Veuillez lire attentivement ces Conditions avant d&apos;utiliser nos Services.
              </p>
            </div>

            {/* Le reste du contenu peut être ajouté ici si nécessaire */}
          </div>
        </div>
      </div>
    </>
  );
}
